function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stqr{fill:#C92941 !important;}\r\n\t.st1{fill:#1B1464;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21997",
  className: "stqr",
  d: "M75.1,31.1c-1.8,0-3.4,0.9-4.3,2.5H9.4c-0.9-1.5-2.6-2.5-4.3-2.5c-2.7-0.1-5,2.1-5,4.8 c-0.1,2.7,2.1,5,4.8,5C4.9,41,5,41,5,41c1.8,0,3.4-0.9,4.3-2.5h61.4c0.9,1.5,2.6,2.5,4.3,2.5c2.7,0.1,5-2.1,5-4.8 c0.1-2.7-2.1-5-4.8-5C75.3,31.1,75.2,31.1,75.1,31.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.1,9.9v14.8H27V9.9H12.1z M22,14.8v4.9h-4.9v-4.9H22z M7.3,10V5.1h9.8V0.1H2.4v14.7h4.9L7.3,10z M37.5,9.9 h-4.9v4.9h9.9v4.9h4.9V9.9L37.5,9.9L37.5,9.9z M72.8,0h-9.9v4.9h9.9v9.9h4.9V0H72.8z M32.5,19.2h4.9v4.9h-4.9V19.2z M62.9,24.7h4.9 V9.9H53v14.8H62.9L62.9,24.7z M58,14.8h4.9v4.9H58V14.8z M42.6,24h4.9v4.9h-4.9V24z M42.6,43.2h4.9v4.9h-4.9V43.2z M32.5,48h4.9v4.9 h-4.9V48z M27.5,43.2h4.9v4.9h-4.9V43.2z M17.1,47.4h-4.9v14.8H27V47.4H17.1L17.1,47.4z M22,57.3h-4.9v-4.9H22V57.3z M42.5,52.4 h-4.9v4.9h-4.9v4.9h14.8v-4.9h-4.9L42.5,52.4z M7.3,67v-9.8H2.4V72h14.8V67L7.3,67L7.3,67z M67.9,62.2V47.4H53v14.8H67.9z M58,57.3 v-4.9h4.9v4.9H58z M72.8,62.2v4.9h-9.9v4.9h14.8V57.3h-4.9V62.2z"
});

var SvgQrCode = function SvgQrCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14224",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.1 72.1",
    style: {
      enableBackground: "new 0 0 80.1 72.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQrCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qrCode.1b5eecda.svg";
export { ForwardRef as ReactComponent };